/** @format */

import React from 'react';
import '../css/Master.css';
import line from '../images/line.png';

import videoMasterImage from '../images/Marcos - render-final-con-mas-luz (1).jpg';

import decoration1 from '../images/decorations/02.png';
import decoration2 from '../images/decorations/04.png';

import { IoPlay } from 'react-icons/io5';
import { useDispatch } from 'react-redux';
import { openVideo } from '../features/video';
import Image from 'react-image-webp';

import backgroundRight from '../images/2-resize.jpg';
import backgroundRightWebp from '../images/2-resize.webp';

import backgroundLeftResize from '../images/1-resize.jpg';
import backgroundLeftWebpResize from '../images/1-resize.webp';

const Master = () => {
  const dispatch = useDispatch();

  return (
    <section className='Master' id='contenido'>
      <div className='master-background'>
        <div className='master-left'>
          <Image
            src={backgroundLeftResize}
            webp={backgroundLeftWebpResize}
            alt='background'
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
              position: 'relative',
              left: '-10%',
            }}
          />
        </div>
        <div className='master-right'>
          <Image
            src={backgroundRight}
            webp={backgroundRightWebp}
            alt='background'
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
            }}
          />
        </div>
      </div>
      <div className='master-filter'></div>
      <div className='master-container container padding'>
        <img
          src={decoration1}
          alt='Master Decoration'
          className='decoration-1'
        />
        <img
          src={decoration2}
          alt='Master Decoration'
          className='decoration-2'
        />

        <div className='master-header'>
          <h1 className='master-title'>
            Domina ZBrush{' '}
          </h1>
          <h2 className='master-subtitle'>
              Online en vivo
              <img src={line} alt='underline' />
            </h2>
          <p className='header-paragraph'>
            Estudia online con FEEDBACK en vivo y en Discord y tendrás
            acompañamiento por un mes y medio y acceso al contenido un
            año.
          </p>
        </div>
        <div className='master-body'>
          <div className='video-master-wrapper'>
            <img
              src={videoMasterImage}
              alt='Master Video'
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
            <button
              className='video-master-play'
              onClick={() => {
                dispatch(
                  openVideo({
                    modal: true,
                    url: 'https://www.youtube.com/watch?v=BO4sQALaWn8',
                    type: 'common',
                  })
                );
              }}>
              <IoPlay />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Master;
